import createReducer from 'shared/utils/createReducer';
import { LOGIN } from 'modules/auth/actions/login';
import { LOGOUT } from 'modules/auth/actions/logout';

import { UNENFORCED, ARCHIVED } from 'modules/queues/constants/queueEnforcementTypes';
import {
  UPDATE_APPOINTMENTS_TOTAL_COUNT,
  HIDE_APPOINTMENT_INFO,
  SHOW_APPOINTMENT_INFO,
} from 'modules/queues/common/actions/appointmentInfo';
import { CLOSE_ARCHIVE, OPEN_ARCHIVE } from 'modules/queues/Archive/actions/archive';
import { CHECK_CLOSEST_APPOINTMENT } from '../actions/closestAppointment';
import { SET_GROUP_APPOINTMENTS_IDS } from '../actions/resubscribeGroupAppointmentsUpdate';

const defaultState = {
  firstAppointmentCheckCompleted: false,
  isArchiveOpened: false,
  isAppointmentInfoShown: false,
  appointmentId: null,
  groupAppointmentsIds: [],
  queuesSize: {
    [ARCHIVED]: 0,
    [UNENFORCED]: 0,
  },
};

export default createReducer(defaultState, {
  [SHOW_APPOINTMENT_INFO]: (state, { payload: { appointmentId } }) => ({
    ...state,
    isAppointmentInfoShown: true,
    appointmentId,
  }),

  [UPDATE_APPOINTMENTS_TOTAL_COUNT]: (state, { payload: { count, queueType } }) => ({
    ...state,
    queuesSize: {
      ...state.queuesSize,
      [queueType]: count,
    },
  }),

  [OPEN_ARCHIVE]: (state) => ({
    ...state,
    isArchiveOpened: true,
  }),

  [CLOSE_ARCHIVE]: (state) => ({
    ...state,
    isArchiveOpened: false,
  }),

  [HIDE_APPOINTMENT_INFO]: (state) => ({
    ...state,
    isAppointmentInfoShown: false,
    appointmentId: null,
  }),

  [CHECK_CLOSEST_APPOINTMENT.success]: (state) => ({
    ...state,
    firstAppointmentCheckCompleted: true,
  }),

  [CHECK_CLOSEST_APPOINTMENT.failure]: (state) => ({
    ...state,
    firstAppointmentCheckCompleted: true,
  }),

  [SET_GROUP_APPOINTMENTS_IDS]: (state, { payload: { groupAppointmentsIds } }) => ({
    ...state,
    groupAppointmentsIds,
  }),

  [LOGIN.success]: () => defaultState,
  [LOGOUT.failure]: () => defaultState,
  [LOGOUT.success]: () => defaultState,
});
